import { render } from "./SignupPageBranded.vue?vue&type=template&id=76b8ae74&scoped=true&ts=true"
import script from "./SignupPageBranded.vue?vue&type=script&lang=ts"
export * from "./SignupPageBranded.vue?vue&type=script&lang=ts"

import "./SignupPageBranded.vue?vue&type=style&index=0&id=76b8ae74&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76b8ae74"]])

export default __exports__